var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 13.3C1.015 13.3 0.685533 13.163 0.4116 12.8891C0.137667 12.6152 0.000466667 12.2855 0 11.9V4.2C0 3.815 0.1372 3.48553 0.4116 3.2116C0.686 2.93767 1.01547 2.80047 1.4 2.8H4.2V1.4C4.2 1.015 4.3372 0.685533 4.6116 0.4116C4.886 0.137667 5.21547 0.000466667 5.6 0H8.4C8.785 0 9.1147 0.1372 9.3891 0.4116C9.6635 0.686 9.80047 1.01547 9.8 1.4V2.8H12.6C12.985 2.8 13.3147 2.9372 13.5891 3.2116C13.8635 3.486 14.0005 3.81547 14 4.2V11.9C14 12.285 13.863 12.6147 13.5891 12.8891C13.3152 13.1635 12.9855 13.3005 12.6 13.3H1.4ZM1.4 11.9H12.6V4.2H1.4V11.9ZM5.6 2.8H8.4V1.4H5.6V2.8Z",
    fill: "#2D3892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.74420b5bca778f7c4862f8a93252f624.svg";
export { ForwardRef as ReactComponent };